"use strict";
module.exports = {
    'v1.supplierCustomer.setDeliveryRules': 'crm',
    'v1.supplierCustomer.writeCustomer': 'crm',
    'v1.supplierCustomer.importCustomer': 'crm',
    'v1.supplierCustomer.writeContact': 'crm',
    'v1.supplierCustomer.deactivate': 'crm',
    'v1.supplierCustomer.activate': 'crm',
    'v1.supplierCustomer.removeContact': 'crm',
    'v1.supplierCustomer.approveSupplierCustomer': 'crm',
    'v1.supplierCustomer.blockSupplierCustomer': 'crm',
    'v1.supplierCustomer.unblockSupplierCustomer': 'crm',
    'v1.supplierCustomer.changeOrderFullfillmentCenter': 'crm',
    'v1.supplierCustomer.approveAlcoholLicense': 'crm',
    'v1.supplierCustomer.revokeAlcoholLicense': 'crm',
    'v1.supplierCustomer.upsert': 'crm',
    'v1.supplierCustomer.upsertWhenEmpty': 'crm',
    'v1.supplierCustomer.updateWhenEmpty': 'crm',
    'v1.supplierCustomer.update': 'crm',
    'v1.ofcInCrm.upsert': 'crm',
    'v1.ofcInCrm.upsertWhenEmpty': 'crm',
    'v1.ofcInCrm.updateWhenEmpty': 'crm',
    'v1.ofcInCrm.update': 'crm',
    'v1.activity.writeActivity': 'crm',
    'v1.activity.finish': 'crm',
    'v1.activity.upsert': 'crm',
    'v1.activity.upsertWhenEmpty': 'crm',
    'v1.activity.updateWhenEmpty': 'crm',
    'v1.activity.update': 'crm',
    'v1.userInCrm.upsert': 'crm',
    'v1.userInCrm.upsertWhenEmpty': 'crm',
    'v1.userInCrm.updateWhenEmpty': 'crm',
    'v1.userInCrm.update': 'crm',
    'v1.crmEventsource.cleanUpOldEvents': 'crm',
    'v1.crmEventsource.undoEvent': 'crm',
    'v1.crmEventsource.reEmit': 'crm',
};
